export const MOTION_EASE = {
  enter: [0.22, 1, 0.36, 1],
  snap: [0.16, 1, 0.3, 1],
  standard: [0.4, 0, 0.2, 1],
  exit: [0.4, 0, 1, 1],
  editorial: [0.25, 0.46, 0.45, 0.94],
};

export const MOTION_DURATION = {
  micro: 0.12,
  fast: 0.18,
  base: 0.22,
  page: 0.35,
  reveal: 0.5,
  chart: 0.7,
  entrance: 0.86,
};

export const MOTION_SPRING = {
  snappy: { type: "spring", stiffness: 480, damping: 32 },
  pop: { type: "spring", stiffness: 420, damping: 26 },
  gentle: { type: "spring", stiffness: 220, damping: 28 },
};

export const MOTION_REVEAL = {
  hidden: { opacity: 0, y: 14 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: MOTION_DURATION.reveal, ease: MOTION_EASE.enter },
  },
};

export const MOTION_FILTER_ITEM = {
  initial: { opacity: 0, y: 14 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: 14, transition: { duration: MOTION_DURATION.micro, ease: MOTION_EASE.exit } },
  transition: { layout: MOTION_SPRING.snappy, opacity: { duration: MOTION_DURATION.fast }, y: MOTION_SPRING.snappy },
};

export const MOTION_FILTER_FEEDBACK = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  transition: { duration: MOTION_DURATION.micro },
};

export const MOTION_PRESS = { scale: 0.98, transition: { duration: MOTION_DURATION.micro } };

export const MOTION_ARTICLE_HERO = {
  revealDistance: 0.5,
  revealStart: 0.08,
  revealEnd: 0.85,
  zoom: 1.08,
  scrim: 0.6,
  copyOffset: 24,
};

export const MOTION_PAGE = {
  initial: { opacity: 0, y: 12 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -12 },
  transition: { duration: MOTION_DURATION.page, ease: "easeOut" },
};

export const MOTION_TOOL_STAGGER = {
  hidden: {},
  visible: { transition: { delayChildren: 0.42, staggerChildren: 0.16 } },
};

export const MOTION_TOOL_GROUP = {
  hidden: {},
  visible: {},
};

export const MOTION_TOOL_PANEL = {
  hidden: { opacity: 0, y: 18 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: MOTION_DURATION.entrance, ease: MOTION_EASE.enter },
  },
};

export const MOTION_REDUCED = "user";
